import {
    MangoQueryResult,
    QueryGetTicketTemplateByIdArgs,
    QueryGetTicketTemplatesArgs,
    TicketTemplateFragmentFragment
} from "../../../../__generated__/graphql/types";
import gql from "graphql-tag";
import {TicketTemplateFragment} from "../../../../Queries/Veriflyt";
import {useQuery} from "react-apollo";

const QUERY_TICKET_TEMPLATES = gql`
    query VeriflytTicketTemplateSelect_GetTicketTemplates(
        $onScreenName: String
        $limit: Int
        $bookmark: String
    ){
        GetTicketTemplates(onScreenName: $onScreenName, limit: $limit, bookmark: $bookmark){
            docs {
                ... on TicketTemplate {
                    ...TicketTemplateFragment
                }
            }
            bookmark
        }
    }
    ${TicketTemplateFragment}
`

const QUERY_GET_TICKET_TEMPLATE_BY_ID = gql`
    query VeriflytTicketTemplateSelect_GetTicketTemplateByID($ticketTemplateID: ID!){
        GetTicketTemplateByID(ticketTemplateID: $ticketTemplateID){
            ...TicketTemplateFragment
        }
    }
    ${TicketTemplateFragment}
`

export interface UseTicketTemplatesArgs {
    onScreenName?: string,
    limit?: number,
    bookmark?: string
}

export function useTicketTemplatesQuery(args?: UseTicketTemplatesArgs){

    type QueryResult = {
        GetTicketTemplates: MangoQueryResult
    }

    const result = useQuery<QueryResult, QueryGetTicketTemplatesArgs>(QUERY_TICKET_TEMPLATES, {
        variables: {
            onScreenName: args?.onScreenName,
            limit: args?.limit,
            bookmark: args?.bookmark
        },
        fetchPolicy: 'network-only',
        errorPolicy: 'all'
    })

    return {
        ...result,
        data: result?.data?.GetTicketTemplates?.docs as TicketTemplateFragmentFragment[]
    }
}

export function useGetTicketTemplateQuery(ticketTemplateID: string, cacheFirst = false){
    type QueryResult = {
        GetTicketTemplateByID: TicketTemplateFragmentFragment
    }

    const result = useQuery<QueryResult, QueryGetTicketTemplateByIdArgs>(QUERY_GET_TICKET_TEMPLATE_BY_ID, {
        variables: {
            ticketTemplateID: ticketTemplateID
        },
        fetchPolicy: cacheFirst ? 'cache-first' : 'cache-and-network',
        errorPolicy: 'all',
        skip: !ticketTemplateID
    })

    return {
        ...result,
        data: result?.data?.GetTicketTemplateByID
    }
}